//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.StructureDesign.js";
import "../no/TaggedObject.js";
import "../no/Features.js";
let d=[[],[[["stockObject","stockBuilder"],"UpdateStockInformation",{},2,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Features.StructureDesign.InheritStockBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StructureDesign.InheritStockBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.StructureDesign.InheritStockBuilder.StockObjectTypes = Object.freeze({
    "Member" : "Member", "EndCap" : "EndCap", "Gusset" : "Gusset", "GrabTab" : "GrabTab", "Stiffener" : "Stiffener", "BoltedConnection" : "BoltedConnection"});

export default SPLM;